import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2af4f20c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-top-tips-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "商品 ", -1))
const _hoisted_3 = { class: "goods-info-box" }
const _hoisted_4 = { class: "goods-image-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "goods-name-box" }
const _hoisted_7 = {
  key: 0,
  class: "goods-sku-box"
}
const _hoisted_8 = { class: "inner-card-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner-card-left" }, "退款金额：", -1))
const _hoisted_10 = { class: "inner-card-right" }
const _hoisted_11 = { class: "inner-card-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner-card-left" }, "退款备注：", -1))
const _hoisted_13 = { class: "inner-card-right" }
const _hoisted_14 = { class: "return-remake-box" }
const _hoisted_15 = { class: "red" }
const _hoisted_16 = { class: "align-right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _ctx.ruleForm,
    style: {"padding":"20px"},
    rules: _ctx.rules,
    "label-width": "100px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, "可剩余退款金额 " + _toDisplayString(_ctx.canReturnAmount), 1),
      _createVNode(_component_ui_table, {
        data: _ctx.orderInfo.orderGoods,
        style: {"margin-top":"10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, null, {
            header: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: row.goodsDetails.cover,
                    v: ""
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(row.goodsDetails.name), 1),
                  (row.goodsDetails.skuName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row.goodsDetails.skuName), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "num",
            width: "80",
            label: "数量"
          }),
          _createVNode(_component_el_table_column, {
            prop: "price",
            width: "80",
            label: "单价"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.amount,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.amount) = $event)),
            placeholder: "请输入退款金额"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.ruleForm.replyMessage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.replyMessage) = $event)),
            placeholder: "请输入退款备注"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode("退款给买家/付款人："),
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.showAmount), 1)
      ]),
      _createVNode(_component_el_form_item, { style: {"margin-top":"20px"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.submitForm
            }, {
              default: _withCtx(() => [
                _createTextVNode("退款")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}